var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolio1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 686.18 334.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: url(#linear-gradient);\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 1.77px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-2);\n        opacity: .19;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 197.62,
    y1: 417.81,
    x2: 486.97,
    y2: -83.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7427e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#de4681"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#c7548a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a16a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6c89ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#29b0c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 198.1,
    y1: 416.98,
    x2: 486.5,
    y2: -82.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 190.76,
    y1: 431.38,
    x2: 496.08,
    y2: -97.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5182e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#cc1f34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#b53248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8f5267"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#5a7e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#17b6c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08c4d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "index"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M648.18,323.63H36.42c-10.07-10.07-15.72-15.72-25.79-25.79V36.6c10.07-10.07,15.72-15.72,25.79-25.79h611.76c10.07,10.07,15.72,15.72,25.79,25.79v261.24c-10.07,10.07-15.72,15.72-25.79,25.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M648.18,323.63H36.42c-10.07-10.07-15.72-15.72-25.79-25.79V36.6c10.07-10.07,15.72-15.72,25.79-25.79h611.76c10.07,10.07,15.72,15.72,25.79,25.79v261.24c-10.07,10.07-15.72,15.72-25.79,25.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.3,333.95H22L.66,311.56v-143.31l1.76,2.61v139.93l20.3,21.31h88.33l1.25,1.85ZM308.55.49H22L.66,22.89v55.83l1.76,1.85V23.65L22.73,2.34h284.07l1.76-1.85ZM559.94,0h-22.01l-1.76,1.85h22.01l1.76-1.85ZM522.44,0h-22.01l-1.76,1.85h22.01l1.76-1.85ZM483.44,0h-22.01l-1.76,1.85h22.01l1.76-1.85ZM443.69,0h-22.01l-1.76,1.85h22.01l1.76-1.85ZM599.78,0h-20.03l-1.76,1.85h20.03l1.76-1.85ZM664.84,0h-45.25l-1.76,1.85h46.28l20.3,21.31v287.14l-20.3,21.31h-366.43l1.76,1.85h365.4l21.34-22.39V22.39l-21.34-22.39ZM1.87,152.1c-1.03,0-1.87.88-1.87,1.96s.84,1.96,1.87,1.96,1.87-.88,1.87-1.96-.84-1.96-1.87-1.96ZM1.87,139.4c-1.03,0-1.87.88-1.87,1.96s.84,1.96,1.87,1.96,1.87-.88,1.87-1.96-.84-1.96-1.87-1.96ZM1.87,129.46c-1.03,0-1.87.88-1.87,1.96s.84,1.96,1.87,1.96,1.87-.88,1.87-1.96-.84-1.96-1.87-1.96ZM263.82,332.48c0-1.08-.84-1.96-1.87-1.96s-1.87.88-1.87,1.96.84,1.96,1.87,1.96,1.87-.88,1.87-1.96ZM275.93,332.48c0-1.08-.84-1.96-1.87-1.96s-1.87.88-1.87,1.96.84,1.96,1.87,1.96,1.87-.88,1.87-1.96ZM285.39,332.48c0-1.08-.84-1.96-1.87-1.96s-1.87.88-1.87,1.96.84,1.96,1.87,1.96,1.87-.88,1.87-1.96Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio1);
export default __webpack_public_path__ + "static/media/portfolio 1.13169439258fdc535fc008da5efb8778.svg";
export { ForwardRef as ReactComponent };